import io from 'socket.io-client';
import lodash from 'lodash';
import axios from 'axios';
// import { history } from '../../config/history';
// import { initApp } from '../../index';
import { showNotifications } from '../../config/notifications';
import config from '../../config/sbf_config';

// const token = localStorage.getItem('token');

class Api {
    constructor() {
        this.socket = null;
    }

    getJwtToken = async ({ login, password }) => {
        try {
            const { data: { jwtToken } } = await axios.post(
                `${config.identityServiceUrl}/api/v1/identity/auth/authenticate`,
                { login, password },
            );

            return jwtToken;
        } catch (error) {
            console.error('Failed to get jwtToken: ', error.message);
            return '';
        }
    }

    auth = (credentials) => new Promise((resolve, reject) => {
        this.socket.emit('authentication', credentials);

        this.socket.on('authenticated', async (data) => {
            if (localStorage) {
                localStorage.setItem('token', data.token);
            }

            if (credentials.login && credentials.password) {
                const jwtToken = await this.getJwtToken(credentials);

                localStorage.setItem('jwtToken', jwtToken);
            }

            resolve({
                result: true,
                token: data.token,
            });
        });

        this.socket.on('unauthorized', (error) => {
            console.log('Failed to auth: ', error.message);
            reject(error.message);
        });
    });

    init = (credentials) => new Promise((resolve, reject) => {
        this.socket = io.connect(config.backendUrl, {
            transports: ['websocket', 'polling'],
        });

        this.socket.on('connect', () => {
            console.log('Socket connect....');

            this.auth(credentials).then((authToken) => {
                this.socket.on('error', (error) => console.log(error));
                this.socket.on('disconnect', (data) => console.log('Socket disconnect....', data));
                this.socket.on('reconnecting', (data) => console.log('Socket reconnecting....', data));
                this.socket.on('LogOut', () => {
                    if (localStorage) {
                        localStorage.removeItem('token');
                    }
                    window.location.reload();
                });

                this.socket.on('notification', showNotifications);

                return resolve(authToken);
            }).catch((error) => {
                if (localStorage) {
                    localStorage.removeItem('token');
                }
                return reject(error);
            });
        });
    });

    logout = () => {
        this.socket.emit('LogOut');
    }

    send(params) {
        return new Promise((resolve, reject) => {
            this.socket.json.send(params, (res) => {
                if (lodash.isPlainObject(res) && res.result) {
                    return resolve(res);
                }

                return reject(res);
            });
        });
    }
}

const api = new Api();

window.api = api;
window.API = api;

export default api;



// WEBPACK FOOTER //
// ./src/modules/App/socket.js